import React, { Component } from 'react'
import SwiperSlider from '../../components/SwiperSlider';

import SliderImg1 from '../../images/popup-integrates/1.png';
import SliderImg2 from '../../images/popup-integrates/2.png';
import SliderImg3 from '../../images/popup-integrates/3.jpg';
import SliderImg4 from '../../images/popup-integrates/4.png';
import SliderImg5 from '../../images/popup-integrates/5.png';
import SliderImg6 from '../../images/popup-integrates/6.png';
import SliderImg7 from '../../images/popup-integrates/7.png';
import SliderImg8 from '../../images/popup-integrates/8.png';
import SliderImg9 from '../../images/popup-integrates/9.png';
import SliderImg10 from '../../images/popup-integrates/10.png';
import SliderImg11 from '../../images/popup-integrates/11.png';
import SliderImg12 from '../../images/popup-integrates/12.png';
import SliderImg13 from '../../images/popup-integrates/13.png';
import SliderImg14 from '../../images/popup-integrates/14.png';
import SliderImg15 from '../../images/popup-integrates/15.png';
import SliderImg16 from '../../images/popup-integrates/16.png';
import SliderImg17 from '../../images/popup-integrates/17.png';
import SliderImg18 from '../../images/popup-integrates/18.png';
import SliderImg19 from '../../images/popup-integrates/19.png';
import SliderImg20 from '../../images/popup-integrates/20.png';
import SliderImg21 from '../../images/popup-integrates/21.png';
import SliderImg22 from '../../images/popup-integrates/22.jpg';
import SliderImg23 from '../../images/popup-integrates/23.png';
import SliderImg24 from '../../images/popup-integrates/24.png';

const Slides1 = [
    {
        img: SliderImg1
    },
    {
        img: SliderImg2
    },
    {
        img: SliderImg3
    },
    {
        img: SliderImg4
    },
    {
        img: SliderImg5
    },
    {
        img: SliderImg6
    },
    {
        img: SliderImg7
    },
    {
        img: SliderImg8
    },
    {
        img: SliderImg9
    },
    {
        img: SliderImg10
    },
    {
        img: SliderImg11
    },
    {
        img: SliderImg12
    },
];
const Slides2 = [
    {
        img: SliderImg13
    },
    {
        img: SliderImg14
    },
    {
        img: SliderImg15
    },
    {
        img: SliderImg16
    },
    {
        img: SliderImg17
    },
    {
        img: SliderImg18
    },
    {
        img: SliderImg19
    },
    {
        img: SliderImg20
    },
    {
        img: SliderImg21
    },
    {
        img: SliderImg22
    },
    {
        img: SliderImg23
    },
    {
        img: SliderImg24
    },
];

class IntegrationPopupClients extends Component {
    render() {
        return (
            <div className="integration-popup-clients-section">
                
                <div className="container">
                    <div className="hero-content wow fadeIn text-center mb-5">
                        <h2 className="text-2xl md:text-28px lg:text-32px">Integrate With  <span className="style-highlight"> Top 20+ ESPs
                        <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFF00" viewBox="0 0 500 150" preserveAspectRatio="none"><path d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7"></path></svg></span> and Webhooks</h2>
                        <p className="text-sm md:text-base lg:text-lg font-normal">Collect your captured email leads in one place. Integrate with some of the best ESPs and webhooks in the industry <br/> seamlessly. And carry out multiple actions in autopilot.</p>
                    </div>
                    <div className="position-relative pt-3">
                        <SwiperSlider slidesPerView={8} slides={Slides1} spaceBetween={0} slideDeley={3000} />
                        <SwiperSlider slidesPerView={8} slides={Slides2} spaceBetween={0} slideDeley={3000} dir="rtl" />
                    </div>
                </div>
            </div>
        )
    }
}

export default IntegrationPopupClients
